// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const SignoutSVG = styled(Icon).attrs({ viewBox: '0 0 20 20' })``;

const Signout = ({ color = navy, ...props }) => (
    <SignoutSVG data-test="icon-signout" {...props}>
        <g clip-path="url(#clip0)" fill={color}>
            <path d="M10 20a10 10 0 110-20 10 10 0 010 20zm0-17.86a7.86 7.86 0 10-.01 15.72A7.86 7.86 0 0010 2.14z" />
            <path d="M7.439 6.001L6.003 7.437l6.566 6.565 1.435-1.435L7.44 6z" />
            <path d="M12.569 5.998l-6.566 6.565L7.44 14l6.565-6.566-1.435-1.435z" />
        </g>
        <defs>
            <clipPath id="clip0">
                <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
        </defs>
    </SignoutSVG>
);

export { Signout as default, Signout };
